import * as ambassadorWixCrmInboxV2Message from './crm-inbox-v2-message-messages.http.js';
import * as ambassadorWixCrmInboxV2MessageTypes from './crm-inbox-v2-message-messages.types.js';
import * as ambassadorWixCrmInboxV2MessageUniversalTypes from './crm-inbox-v2-message-messages.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listMessages(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixCrmInboxV2MessageUniversalTypes.ListMessagesRequest,
  ambassadorWixCrmInboxV2MessageTypes.ListMessagesRequest,
  ambassadorWixCrmInboxV2MessageUniversalTypes.ListMessagesResponse,
  ambassadorWixCrmInboxV2MessageTypes.ListMessagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCrmInboxV2Message.listMessages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/messages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function sendMessage(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCrmInboxV2MessageUniversalTypes.SendMessageRequest,
  ambassadorWixCrmInboxV2MessageTypes.SendMessageRequest,
  ambassadorWixCrmInboxV2MessageUniversalTypes.SendMessageResponse,
  ambassadorWixCrmInboxV2MessageTypes.SendMessageResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixCrmInboxV2Message.sendMessage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/messages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
